
import {Component, Vue, Watch} from "vue-property-decorator";
import debounce from "debounce";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component
export default class AdminLogin extends Vue {

  @Watch("search")
  public handlerSearch = debounce(this.searchUsers, 500);

  private users: object[] = [];
  private headers: object[] = [
    {value: "firstName", sortable: true},
    {value: "lastName", sortable: true},
    {value: "email", sortable: true},
    {value: "createdAt", sortable: true},
    {value: "role", sortable: false},
    {value: "activatedAt", sortable: true},
    {value: "lastLoginAt", sortable: true},
    {value: "action", sortable: false},
  ];
  private dialog: boolean = false;
  private loading: boolean = true;

  private pagination: any = {
    sortDesc: [true],
    sortBy: ["updatedAt"],
    page: 1,
    itemsPerPage: 10,
    totalItems: 10,
    rowsPerPageItems: [1, 2, 4, 8, 16],
  };

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  private showArchivedUsers: boolean = false;
  private search = "";

  @Watch("pagination", { deep: true })
  public handler() {
    this.getUsers();
  }

  private reset() {
    this.getUsers();
  }

  private getUserRole(user: any): string {
      if (user.isAdmin) {
          return "admin";
      } else if (user.isDemo) {
          return "demo";
      } else if (user.ManagersRelations?.length) {
          return "master";
      } else if (user.Relays?.length) {
          return "referent";
      } else if (user.companyId) {
          return "manager";
      }
      return "classic";
  }

  private getRoleColor(role: string): string {
      switch (role) {
          case "admin": return "#DD2C00";
          case "demo": return "#FFA726";
          case "master": return "#9575CD";
          case "referent": return "#616161";
          case "manager": return "#42A5F5";
          case "classic": return "default";
          default: return "default";
      }
  }

  private getRoleIcon(role: string): string {
      switch (role) {
          case "admin": return "icon-picto_dossiers-favoris";
          case "demo": return "icon-picto_cartographie";
          case "master": return "icon-picto_company";
          case "referent": return "icon-picto_loby";
          case "manager": return "icon-picto_mes-contacts";
          case "classic": return "icon-picto_cle-partagees";
          default: return "";
      }
  }

  private searchUsers() {
    if (this.pagination.page !== 1) {
      this.pagination.page = 1;
    } else {
      this.getUsers();
    }
  }

  private getUsers() {
    this.loading = true;
    const query = {
      ...{...this.pagination, search : this.search},
      archived: this.showArchivedUsers,
    };
    return this.$store.dispatch("admin/users/getUsers", { query })
      .then((res) => {
        this.users = res.users;
        this.users.forEach((user: any) => {
          user.role = this.getUserRole(user);
        });
        this.pagination.totalItems = res.count;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private sendReminder(user) {
    if (confirm(this.$t("user.sendValidationEmail").toString())) {
        this.$store.dispatch("public/password/forgottenPasswordFn", {email: user.email})
        .then((res) => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$t("user.validationMailSent") + user.email,
            });
        });
    }
  }

  private logAs(user) {
    this.$store.dispatch("auth/logAs", {user});
  }

  private close() {
    this.dialog = false;
  }
}
